import { connect } from 'react-redux';
import { useState } from 'react';
import { Box, ListItemText, ListItem } from '@mui/material';
import BaseFieldEditor from './BaseFieldEditor';
import ConfidenceIndicator from '../ConfidenceIndicator';
import EquipmentTypeSelector from '../selectors/EquipmentTypeSelector';

const EquipmentTypeEditor = ({
  open,
  column,
  actions,
  editing,
  setCurrentlyEditing,
  setCurrentEditor,
  equipTypes,
  loading,
}) => {
  const rawPredictions = editing[0].data?.['auto_tagger.equip_type_preds'] || '{}';
  const predictions =
    typeof rawPredictions === 'string'
      ? JSON.parse(rawPredictions.replaceAll("'", '"')) || {}
      : rawPredictions;
  const [selectedOption, setSelectedOption] = useState(equipTypes[editing[0].equipment_type_id]);

  if (!editing || editing.length <= 0) return null;

  return (
    <BaseFieldEditor
      open={open}
      onSave={() => {
        const action = actions.find((a) => a.id === column.action);
        action.doSave(editing, {
          equipment_type: {
            id: selectedOption.id,
            confidence: 100,
          },
        });
        action.doClose({ setCurrentlyEditing, setCurrentEditor });
      }}
      title="Equipment Type Editor"
      editing={editing}
      column={column}
      setCurrentlyEditing={setCurrentlyEditing}
      setCurrentEditor={setCurrentEditor}
      actions={actions}
      loading={loading}
    >
      <EquipmentTypeSelector
        value={selectedOption}
        setValue={setSelectedOption}
        sortOptions={(a, b) => {
          if (editing.length !== 1) return 0;
          const aConfidence = predictions[a.tagName] || 0;
          const bConfidence = predictions[b.tagName] || 0;
          return bConfidence - aConfidence;
        }}
        renderOption={(props, option) => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <ListItem {...props}>
            <Box width="45px" height="35px">
              {editing.length === 1 && predictions[option.tagName] && (
                <ConfidenceIndicator value={predictions[option.tagName] * 100} />
              )}
            </Box>
            <ListItemText>{option.tagName}</ListItemText>
          </ListItem>
        )}
      />
    </BaseFieldEditor>
  );
};

export default connect(
  ({
    entities: {
      equipTypes: { byId: equipTypes },
    },
  }) => ({
    equipTypes,
  })
)(EquipmentTypeEditor);
